import React from 'react';
import { format, isSameDay, isToday, isBefore } from 'date-fns';
import { Button } from '../../../../UIKit';
import classNames from 'classnames';
import {
  CHARCOAL_GREY,
  PRIMARY_BLUE,
  FITOGRAM_BLUE_DARK_2,
  WHITE,
} from '../../../../Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

interface CalendarDayProps {
  day: Date;
  selectedDay: Date;
  eventCount: number;
  onClick: (day: Date) => void;
}

const useStyles = makeStyles({
  CalendarDayContainer: {
    flexBasis: '14.2857%',
    maxWidth: '14.2857%',
    overflow: 'hidden',
    position: 'relative',
    height: 45,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  eventDot: {
    position: 'absolute',
    width: 5,
    height: 5,
    bottom: 0,
    fontWeight: 'lighter',
    fontSize: 15,
    backgroundColor: CHARCOAL_GREY,
    borderRadius: '100%',
  },
  CalendarDayContainerPast: {
    opacity: 0.4,
  },
  day: {
    borderRadius: '100%',
    width: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: 18,
    minWidth: 0,
    color: CHARCOAL_GREY,
    '&:hover': {
      backgroundColor: FITOGRAM_BLUE_DARK_2,
      color: WHITE,
    },
  },
  selectedDay: {
    color: WHITE,
    backgroundColor: PRIMARY_BLUE,
  },
  today: {
    backgroundColor: `${PRIMARY_BLUE}20`,
  },
});
export default function CalendarDay({ day, eventCount, selectedDay, onClick }: CalendarDayProps) {
  const { classes } = useStyles();
  return (
    <div
      className={classNames({
        [classes.CalendarDayContainer]: true,
        [classes.CalendarDayContainerPast]:
          !isSameDay(selectedDay, day) && !isToday(day) && isBefore(day, new Date()),
      })}
      data-testid={`CalendarDay-${format(day, 'dd')}`}
    >
      <Button
        className={classNames({
          [classes.day]: true,
          [classes.today]: isToday(day) && !isSameDay(selectedDay, day),
          [classes.selectedDay]: isSameDay(selectedDay, day),
        })}
        data-testid={`CalendarDayValue-${format(day, 'dd')}`}
        onClick={() => onClick(day)}
        type="button"
      >
        {format(day, 'dd')}
      </Button>
      {eventCount > 0 && (
        <div
          className={classNames({
            [classes.eventDot]: true,
            [classes.today]: isToday(day) && !isSameDay(selectedDay, day),
            [classes.selectedDay]: isSameDay(selectedDay, day),
          })}
          data-testid={`CalendarDayEventDot-${format(day, 'dd')}`}
        />
      )}
    </div>
  );
}
